import {BPM_MAX, BPM_MIN} from '../constants/constants';

const multipliers = [1 / 4, 1 / 2, 1, 2, 4];

export class BpmCalculator {

    constructor(targetBpm) {
        this.targetBpm = targetBpm;

        this.bpmMultipliers = [];
        multipliers.forEach(mult => {
            let bpmMult = targetBpm * mult;
            if (bpmMult >= BPM_MIN && bpmMult <= BPM_MAX) {
                this.bpmMultipliers.push(targetBpm * mult);
            }
        });
    };


    getScore(bpm, multBpm) {
        let score = Math.abs(bpm - multBpm);
        if (bpm > this.targetBpm) {
            // double for going up
            if (bpm < multBpm) {
                score *= 2;
            }

        } else {
            // double for going down
            if (bpm > multBpm) {
                score *= 2;
            }
        }
        return score;

    };

    calculate(bpm) {
        let scores = [];
        this.bpmMultipliers.forEach(bpmMult => {
            scores.push({
                score: this.getScore(bpm, bpmMult),
                bpm: bpmMult
            });
        });
        scores.sort((a, b) => {
            return (a.score - b.score);
        });
        return scores[0].bpm;
    }
}
